// extracted by mini-css-extract-plugin
export default {"link":"styles_link__FRx0N","buttonsHolder":"styles_buttonsHolder__OKBG9"};